import React from 'react'
import HeadsetMicIcon from '@material-ui/icons/HeadsetMic';
import FlexView from 'react-flexview/lib';
import { FirebaseService, FirebaseConfigKey } from '../../services/FirebaseService';
import DataLayerService from '../../services/DataLayerService';


export const RequesetSupportTag = ({icon, text, tag}) => {

    const onTagClick = () => DataLayerService.pushToDataLayer({'event': 'contact_us_tag_clicked', 'target': tag})

    return (
        <FlexView vAlignContent={'center'} className="margin-top-6">
            {icon || <HeadsetMicIcon className="gray margin-right-6" />}
            <div className="text-small gray">{text} please <a onClick={onTagClick} target="_blank" className="blue" href={FirebaseService.getValue(FirebaseConfigKey.CONTACT_US_URL)}>contact us</a></div>
        </FlexView>
    )
}

export const CustomizedRequestSupportTagFleet = () => {
    const onTagClick = () => DataLayerService.pushToDataLayer({'event': 'contact_us_tag_clicked', 'target': 'fleet-contact-us-tag'})

    return (
        <FlexView vAlignContent={'center'} className="margin-top-6">
            <HeadsetMicIcon className="gray margin-right-6" />
            <div className="text-small gray">do not hesitate to <a onClick={onTagClick} target="_blank" className="blue" href={FirebaseService.getValue(FirebaseConfigKey.CONTACT_US_URL)}>contact us</a> at any time if you need assistance or speak with a live representative.</div>
        </FlexView>
    )
}